import * as React from 'react'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { useParams } from 'react-router-dom'

import Layout from './Layout'
import { State } from '../../model'
import { Model as ProjectViewState } from '../../interfaces/pages/project'
import * as actions from '../../model/project/actions'
import * as projectsActions from '../../model/projects/actions'
import { ProjectId, Project } from '../../interfaces/entities/project'
import { ProjectsFilter, Model } from '../../interfaces/services/projects'
import { Descriptive } from '../../interfaces/base'
import { Creative, CreativeAction } from '../../interfaces/entities/creative'
import { Formatset, FormatsetId } from '../../interfaces/entities/formatset'
import { User } from '../../interfaces/entities/user'
import { useDirtySanchez } from '../../components/DirtySanchez'
import { Platform } from '../../interfaces/entities/platform'

interface Props {
  page: ProjectViewState
  user: User
  projects: Model
  getProjects: (filter: ProjectsFilter | null) => void
  leaveProjectPage: () => any
  getProject: (id: ProjectId) => void
  getPlatforms: () => void
  doProjectAction: (action: Descriptive, project: Project) => void
  doCreativeAction: (creative: Creative, action: CreativeAction) => void
  onProjectSave: (project: Project, meta: { created: boolean }) => any
  setProjectComment: (projectId: ProjectId, comment: string) => any
  addedFormatsets: (formatsets: Formatset[]) => any
  onRemoveFormatSet: (formatsetId: FormatsetId) => any
  platforms: Platform[]
  DirtySanchezProvider: any
}

const Main = (props: Props) => {
  const { clean } = useDirtySanchez()
  const { id } = useParams()

  useEffect(() => {
    props.getPlatforms()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      props.leaveProjectPage()
      clean('project')
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (id) {
      props.getProject(id)
    }
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout
      {...props}
      {...props.page}
      user={props.user}
      clickOnProjectAction={props.doProjectAction}
      doCreativeAction={props.doCreativeAction}
      onProjectSave={props.onProjectSave}
      setProjectComment={props.setProjectComment}
      addedFormatsets={props.addedFormatsets}
      onRemoveFormatSet={props.onRemoveFormatSet}
      getProject={props.getProject}
      platforms={props.platforms}
    />
  )
}

const mapStateToProps = (state: State) => {
  return {
    page: state.project,
    user: state.user,
    platforms: state.project.platforms,
  }
}
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getProjects: (filter: ProjectsFilter | null) =>
      dispatch(projectsActions.getProjects(filter)),
    getProject: (id: ProjectId) => dispatch(actions.getProject(id)),
    doProjectAction: (action: Descriptive, project: Project) =>
      dispatch(actions.doProjectAction(action, project)),
    doCreativeAction: (creative: Creative, action: CreativeAction) => {
      return dispatch(actions.doCreativeAction(creative, action))
    },
    onProjectSave: (project: Project, meta: { created: boolean }) => {
      return dispatch(actions.saveProject(project))
    },
    setProjectComment: (projectId: ProjectId, comment: string) =>
      dispatch(actions.setProjectComment(projectId, comment)),
    addedFormatsets: (formatsets: Formatset[]) =>
      dispatch(actions.addedFormatsets(formatsets)),
    onRemoveFormatSet: (formatsetId: FormatsetId) =>
      dispatch(actions.removeFormatSet(formatsetId)),
    leaveProjectPage: () => dispatch(actions.leaveProjectPage()),
    getPlatforms: () => dispatch(actions.getPlatforms()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
